import styled from "styled-components"
import {Row} from "react-bootstrap"

import {minWidthMedia} from "@irati/ui/src/global/media"

import SearchInput from "../../SearchInput/SearchInput"

export const StyledSearchInput = styled(SearchInput)`
  margin-bottom: 10px;

  ${minWidthMedia.tablet`
    margin-bottom: 0;
  `}
`

export const FlexRow = styled(Row)`
  display: flex;
  align-items: center;
  flex-direction: column;

  ${minWidthMedia.tablet`
    flex-direction: row;
`}
`
